import * as Yup from 'yup';
import { fields } from '@synergy/utils';

import { NotificationSettingFormValues } from '../../models/notification-form-values';

export const fieldNames = fields<NotificationSettingFormValues>();

export const notificationsModalValidationSchema = Yup.object().shape({
    [fieldNames.notificationType]: Yup.string().required('app.error.required'),
    [fieldNames.notificationOrigin]: Yup.string().required('app.error.required'),
    [fieldNames.overrideEmail]: Yup.boolean(),
    [fieldNames.recipientEmail]: Yup.mixed().when(fieldNames.overrideEmail, {
        is: true,
        then: Yup.string().required('app.error.required').email('app.error.email'),
    }),
});
